import { render, staticRenderFns } from "./AddStockTaking.vue?vue&type=template&id=ba79d9d8"
import script from "./AddStockTaking.vue?vue&type=script&lang=js"
export * from "./AddStockTaking.vue?vue&type=script&lang=js"
import style0 from "./AddStockTaking.vue?vue&type=style&index=0&id=ba79d9d8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_84b6d598d32b1da7294c0119ce301628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports